import React from 'react';
import { Text } from '@gravity-ui/uikit';
import { videoListT } from '../../../i18n';

export function EmptyVideoListMessage() {
    return (
        <div
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}
        >
            <Text variant="body-2" color="secondary">
                {videoListT('emptyList')}
            </Text>
            <img
                src="./SadMascot.png"
                alt="Sad mascot"
                style={{
                    width: '24px',
                    height: '24px',
                }}
            />
        </div>
    );
}
